export const fileterTestData = [
  {
    gate: "AND",
    key: "f1ea073e-0f8e-47a2-9e97-a1fdbdd03a2b",
    label: "Project Project",
    id: "f1ea073e-0f8e-47a2-9e97-a1fdbdd03a2b",
    parentId: "f1ea073e-0f8e-47a2-9e97-a1fdbdd03a2b",
    treeVisible: true,
    nodes: [
      {
        id: "ecd9eb3c-c64e-4921-88af-63046ed0f5e5",
        parentId: "f1ea073e-0f8e-47a2-9e97-a1fdbdd03a2b",
        treeVisible: true,
        key: "ecd9eb3c-c64e-4921-88af-63046ed0f5e5",
        label: "Walls",
        nodes: [
          {
            id: "d1609407-9100-4189-9d47-12adb66efea3",
            parentId: "ecd9eb3c-c64e-4921-88af-63046ed0f5e5",
            treeVisible: true,
            key: "d1609407-9100-4189-9d47-12adb66efea3",
            label: "Wall-Ext_102Bwk-75Ins-100LBlk-12P",
            nodes: [
              {
                id: "d7410c51-d3b5-4ea6-8686-ce368aac17e3",
                parentId: "d1609407-9100-4189-9d47-12adb66efea3",
                key: "d7410c51-d3b5-4ea6-8686-ce368aac17e3",
                treeVisible: true,
                label: "Wall-Ext_102Bwk-75Ins-100LBlk-12P",
                meshInfo: {
                  $id: "d7410c51-d3b5-4ea6-8686-ce368aac17e3",
                  CustomCategory: null,
                  TopCategory: "Walls",
                  SubCategory: "Walls",
                  PhysicalCategory: "Walls",
                  Type: "Basic Wall",
                  Name: "Wall-Ext_102Bwk-75Ins-100LBlk-12P",
                  Quantity: 1,
                  Unit: "",
                  Count: 1,
                  Area: 70.58624335802492,
                  AreaUnit: "SquareMeter",
                  RevitAreaUnit: "Square meters",
                  Volume: 20.32023564408941,
                  VolumeUnit: "CubicMeter",
                  RevitVolumeUnit: "Cubic meters",
                  NominalWeight: 0,
                  NominalWeightUnit: "Undefined",
                  RevitNominalWeightUnit: "",
                  Length: 8600,
                  LengthUnit: "Millimeter",
                  RevitLengthUnit: "Millimeters",
                  Width: 290,
                  WidthUnit: "Millimeter",
                  RevitWidthUnit: "Millimeters",
                  Depth: 7999.999999999999,
                  DepthUnit: "Millimeter",
                  RevitDepthUnit: "Millimeters",
                  Connectors: [],
                  Diameter: 0,
                  DiameterUnit: "Undefined",
                  ConnectorWidth: 0,
                  ConnectorWidthUnit: "Undefined",
                  ConnectorHeight: 0,
                  ConnectorHeightUnit: "Undefined",
                  Perimeter: 0,
                  PerimeterUnit: "Undefined",
                  MaterialIds: [],
                  MaterialNames: [],
                  LevelName: "Level 0",
                  Uniformat: "",
                  OmniClass: null,
                  MasterFormat: null,
                  UniqueId: "f2a469cf-255d-48c6-9a06-6b3e70144c2f-0004e483",
                  Color: "181, 230, 179",
                  MaterialsData: [
                    {
                      $ref: "29cf1a5b-d6d0-4e44-93a0-5916076244f1",
                    },
                    {
                      $ref: "ac5f2f80-35d3-4b5e-a923-e56a59db027d",
                    },
                    {
                      $ref: "3b99d9f0-c307-4597-ba18-8546195b1c8e",
                    },
                    {
                      $ref: "b777b417-7558-4439-9478-6fe8e382264e",
                    },
                  ],
                },
                nodes: [],
              },
              {
                id: "a37bc96e-a4be-48a1-adae-a7e55b5714a5",
                parentId: "d1609407-9100-4189-9d47-12adb66efea3",
                key: "a37bc96e-a4be-48a1-adae-a7e55b5714a5",
                treeVisible: true,
                label: "Wall-Ext_102Bwk-75Ins-100LBlk-12P",
                meshInfo: {
                  $id: "a37bc96e-a4be-48a1-adae-a7e55b5714a5",
                  CustomCategory: null,
                  TopCategory: "Walls",
                  SubCategory: "Walls",
                  PhysicalCategory: "Walls",
                  Type: "Basic Wall",
                  Name: "Wall-Ext_102Bwk-75Ins-100LBlk-12P",
                  Quantity: 1,
                  Unit: "",
                  Count: 1,
                  Area: 34.06907213721681,
                  AreaUnit: "SquareMeter",
                  RevitAreaUnit: "Square meters",
                  Volume: 9.712626013104268,
                  VolumeUnit: "CubicMeter",
                  RevitVolumeUnit: "Cubic meters",
                  NominalWeight: 0,
                  NominalWeightUnit: "Undefined",
                  RevitNominalWeightUnit: "",
                  Length: 4200,
                  LengthUnit: "Millimeter",
                  RevitLengthUnit: "Millimeters",
                  Width: 290,
                  WidthUnit: "Millimeter",
                  RevitWidthUnit: "Millimeters",
                  Depth: 7999.999999999999,
                  DepthUnit: "Millimeter",
                  RevitDepthUnit: "Millimeters",
                  Connectors: [],
                  Diameter: 0,
                  DiameterUnit: "Undefined",
                  ConnectorWidth: 0,
                  ConnectorWidthUnit: "Undefined",
                  ConnectorHeight: 0,
                  ConnectorHeightUnit: "Undefined",
                  Perimeter: 0,
                  PerimeterUnit: "Undefined",
                  MaterialIds: [],
                  MaterialNames: [],
                  LevelName: "Level 0",
                  Uniformat: "",
                  OmniClass: null,
                  MasterFormat: null,
                  UniqueId: "f2a469cf-255d-48c6-9a06-6b3e70144c2f-0004e48f",
                  Color: "",
                  MaterialsData: [
                    {
                      $ref: "29cf1a5b-d6d0-4e44-93a0-5916076244f1",
                    },
                    {
                      $ref: "ac5f2f80-35d3-4b5e-a923-e56a59db027d",
                    },
                    {
                      $ref: "3b99d9f0-c307-4597-ba18-8546195b1c8e",
                    },
                    {
                      $ref: "b777b417-7558-4439-9478-6fe8e382264e",
                    },
                  ],
                },
                nodes: [],
              },
              {
                id: "4fc246e6-196d-44ff-a72d-b4a6fb6ecc66",
                parentId: "d1609407-9100-4189-9d47-12adb66efea3",
                key: "4fc246e6-196d-44ff-a72d-b4a6fb6ecc66",
                treeVisible: true,
                label: "Wall-Ext_102Bwk-75Ins-100LBlk-12P",
                meshInfo: {
                  $id: "4fc246e6-196d-44ff-a72d-b4a6fb6ecc66",
                  CustomCategory: null,
                  TopCategory: "Walls",
                  SubCategory: "Walls",
                  PhysicalCategory: "Walls",
                  Type: "Basic Wall",
                  Name: "Wall-Ext_102Bwk-75Ins-100LBlk-12P",
                  Quantity: 1,
                  Unit: "",
                  Count: 1,
                  Area: 62.89920110261073,
                  AreaUnit: "SquareMeter",
                  RevitAreaUnit: "Square meters",
                  Volume: 18.223138342806305,
                  VolumeUnit: "CubicMeter",
                  RevitVolumeUnit: "Cubic meters",
                  NominalWeight: 0,
                  NominalWeightUnit: "Undefined",
                  RevitNominalWeightUnit: "",
                  Length: 8000,
                  LengthUnit: "Millimeter",
                  RevitLengthUnit: "Millimeters",
                  Width: 290,
                  WidthUnit: "Millimeter",
                  RevitWidthUnit: "Millimeters",
                  Depth: 7999.999999999999,
                  DepthUnit: "Millimeter",
                  RevitDepthUnit: "Millimeters",
                  Connectors: [],
                  Diameter: 0,
                  DiameterUnit: "Undefined",
                  ConnectorWidth: 0,
                  ConnectorWidthUnit: "Undefined",
                  ConnectorHeight: 0,
                  ConnectorHeightUnit: "Undefined",
                  Perimeter: 0,
                  PerimeterUnit: "Undefined",
                  MaterialIds: [],
                  MaterialNames: [],
                  LevelName: "Level 0",
                  Uniformat: "",
                  OmniClass: null,
                  MasterFormat: null,
                  UniqueId: "f2a469cf-255d-48c6-9a06-6b3e70144c2f-0004e4e2",
                  Color: "",
                  MaterialsData: [
                    {
                      $ref: "29cf1a5b-d6d0-4e44-93a0-5916076244f1",
                    },
                    {
                      $ref: "ac5f2f80-35d3-4b5e-a923-e56a59db027d",
                    },
                    {
                      $ref: "3b99d9f0-c307-4597-ba18-8546195b1c8e",
                    },
                    {
                      $ref: "b777b417-7558-4439-9478-6fe8e382264e",
                    },
                  ],
                },
                nodes: [],
              },
              {
                id: "2ea09ccf-614e-417e-ad66-7075fe4b3258",
                parentId: "d1609407-9100-4189-9d47-12adb66efea3",
                key: "2ea09ccf-614e-417e-ad66-7075fe4b3258",
                treeVisible: true,
                label: "Wall-Ext_102Bwk-75Ins-100LBlk-12P",
                meshInfo: {
                  $id: "2ea09ccf-614e-417e-ad66-7075fe4b3258",
                  CustomCategory: null,
                  TopCategory: "Walls",
                  SubCategory: "Walls",
                  PhysicalCategory: "Walls",
                  Type: "Basic Wall",
                  Name: "Wall-Ext_102Bwk-75Ins-100LBlk-12P",
                  Quantity: 1,
                  Unit: "",
                  Count: 1,
                  Area: 77.80161842132796,
                  AreaUnit: "SquareMeter",
                  RevitAreaUnit: "Square meters",
                  Volume: 22.562469342185025,
                  VolumeUnit: "CubicMeter",
                  RevitVolumeUnit: "Cubic meters",
                  NominalWeight: 0,
                  NominalWeightUnit: "Undefined",
                  RevitNominalWeightUnit: "",
                  Length: 9725.202302665995,
                  LengthUnit: "Millimeter",
                  RevitLengthUnit: "Millimeters",
                  Width: 290,
                  WidthUnit: "Millimeter",
                  RevitWidthUnit: "Millimeters",
                  Depth: 7999.999999999999,
                  DepthUnit: "Millimeter",
                  RevitDepthUnit: "Millimeters",
                  Connectors: [],
                  Diameter: 0,
                  DiameterUnit: "Undefined",
                  ConnectorWidth: 0,
                  ConnectorWidthUnit: "Undefined",
                  ConnectorHeight: 0,
                  ConnectorHeightUnit: "Undefined",
                  Perimeter: 0,
                  PerimeterUnit: "Undefined",
                  MaterialIds: [],
                  MaterialNames: [],
                  LevelName: "Level 0",
                  Uniformat: "",
                  OmniClass: null,
                  MasterFormat: null,
                  UniqueId: "e5d65611-0284-4ee9-be66-0fd1d93ef78f-0004e59f",
                  Color: "",
                  MaterialsData: [
                    {
                      $ref: "29cf1a5b-d6d0-4e44-93a0-5916076244f1",
                    },
                    {
                      $ref: "ac5f2f80-35d3-4b5e-a923-e56a59db027d",
                    },
                    {
                      $ref: "3b99d9f0-c307-4597-ba18-8546195b1c8e",
                    },
                    {
                      $ref: "b777b417-7558-4439-9478-6fe8e382264e",
                    },
                  ],
                },
                nodes: [],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    gate: "OR",
    key: "f1ea073e-0f8e-47a2-9e97-a1fdbdd03a2b",
    label: "Project Project",
    id: "f1ea073e-0f8e-47a2-9e97-a1fdbdd03a2b",
    parentId: "f1ea073e-0f8e-47a2-9e97-a1fdbdd03a2b",
    treeVisible: true,
    nodes: [
      {
        id: "ecd9eb3c-c64e-4921-88af-63046ed0f5e5",
        parentId: "f1ea073e-0f8e-47a2-9e97-a1fdbdd03a2b",
        treeVisible: true,
        key: "ecd9eb3c-c64e-4921-88af-63046ed0f5e5",
        label: "Walls",
        nodes: [
          {
            id: "d1609407-9100-4189-9d47-12adb66efea3",
            parentId: "ecd9eb3c-c64e-4921-88af-63046ed0f5e5",
            treeVisible: true,
            key: "d1609407-9100-4189-9d47-12adb66efea3",
            label: "Wall-Ext_102Bwk-75Ins-100LBlk-12P",
            nodes: [
              {
                id: "d7410c51-d3b5-4ea6-8686-ce368aac17e3",
                parentId: "d1609407-9100-4189-9d47-12adb66efea3",
                key: "d7410c51-d3b5-4ea6-8686-ce368aac17e3",
                treeVisible: true,
                label: "Wall-Ext_102Bwk-75Ins-100LBlk-12P",
                meshInfo: {
                  $id: "d7410c51-d3b5-4ea6-8686-ce368aac17e3",
                  CustomCategory: null,
                  TopCategory: "Walls",
                  SubCategory: "Walls",
                  PhysicalCategory: "Walls",
                  Type: "Basic Wall",
                  Name: "Wall-Ext_102Bwk-75Ins-100LBlk-12P",
                  Quantity: 1,
                  Unit: "",
                  Count: 1,
                  Area: 70.58624335802492,
                  AreaUnit: "SquareMeter",
                  RevitAreaUnit: "Square meters",
                  Volume: 20.32023564408941,
                  VolumeUnit: "CubicMeter",
                  RevitVolumeUnit: "Cubic meters",
                  NominalWeight: 0,
                  NominalWeightUnit: "Undefined",
                  RevitNominalWeightUnit: "",
                  Length: 8600,
                  LengthUnit: "Millimeter",
                  RevitLengthUnit: "Millimeters",
                  Width: 290,
                  WidthUnit: "Millimeter",
                  RevitWidthUnit: "Millimeters",
                  Depth: 7999.999999999999,
                  DepthUnit: "Millimeter",
                  RevitDepthUnit: "Millimeters",
                  Connectors: [],
                  Diameter: 0,
                  DiameterUnit: "Undefined",
                  ConnectorWidth: 0,
                  ConnectorWidthUnit: "Undefined",
                  ConnectorHeight: 0,
                  ConnectorHeightUnit: "Undefined",
                  Perimeter: 0,
                  PerimeterUnit: "Undefined",
                  MaterialIds: [],
                  MaterialNames: [],
                  LevelName: "Level 0",
                  Uniformat: "",
                  OmniClass: null,
                  MasterFormat: null,
                  UniqueId: "f2a469cf-255d-48c6-9a06-6b3e70144c2f-0004e483",
                  Color: "181, 230, 179",
                  MaterialsData: [
                    {
                      $ref: "29cf1a5b-d6d0-4e44-93a0-5916076244f1",
                    },
                    {
                      $ref: "ac5f2f80-35d3-4b5e-a923-e56a59db027d",
                    },
                    {
                      $ref: "3b99d9f0-c307-4597-ba18-8546195b1c8e",
                    },
                    {
                      $ref: "b777b417-7558-4439-9478-6fe8e382264e",
                    },
                  ],
                },
                nodes: [],
              },
              {
                id: "a37bc96e-a4be-48a1-adae-a7e55b5714a5",
                parentId: "d1609407-9100-4189-9d47-12adb66efea3",
                key: "a37bc96e-a4be-48a1-adae-a7e55b5714a5",
                treeVisible: true,
                label: "Wall-Ext_102Bwk-75Ins-100LBlk-12P",
                meshInfo: {
                  $id: "a37bc96e-a4be-48a1-adae-a7e55b5714a5",
                  CustomCategory: null,
                  TopCategory: "Walls",
                  SubCategory: "Walls",
                  PhysicalCategory: "Walls",
                  Type: "Basic Wall",
                  Name: "Wall-Ext_102Bwk-75Ins-100LBlk-12P",
                  Quantity: 1,
                  Unit: "",
                  Count: 1,
                  Area: 34.06907213721681,
                  AreaUnit: "SquareMeter",
                  RevitAreaUnit: "Square meters",
                  Volume: 9.712626013104268,
                  VolumeUnit: "CubicMeter",
                  RevitVolumeUnit: "Cubic meters",
                  NominalWeight: 0,
                  NominalWeightUnit: "Undefined",
                  RevitNominalWeightUnit: "",
                  Length: 4200,
                  LengthUnit: "Millimeter",
                  RevitLengthUnit: "Millimeters",
                  Width: 290,
                  WidthUnit: "Millimeter",
                  RevitWidthUnit: "Millimeters",
                  Depth: 7999.999999999999,
                  DepthUnit: "Millimeter",
                  RevitDepthUnit: "Millimeters",
                  Connectors: [],
                  Diameter: 0,
                  DiameterUnit: "Undefined",
                  ConnectorWidth: 0,
                  ConnectorWidthUnit: "Undefined",
                  ConnectorHeight: 0,
                  ConnectorHeightUnit: "Undefined",
                  Perimeter: 0,
                  PerimeterUnit: "Undefined",
                  MaterialIds: [],
                  MaterialNames: [],
                  LevelName: "Level 0",
                  Uniformat: "",
                  OmniClass: null,
                  MasterFormat: null,
                  UniqueId: "f2a469cf-255d-48c6-9a06-6b3e70144c2f-0004e48f",
                  Color: "",
                  MaterialsData: [
                    {
                      $ref: "29cf1a5b-d6d0-4e44-93a0-5916076244f1",
                    },
                    {
                      $ref: "ac5f2f80-35d3-4b5e-a923-e56a59db027d",
                    },
                    {
                      $ref: "3b99d9f0-c307-4597-ba18-8546195b1c8e",
                    },
                    {
                      $ref: "b777b417-7558-4439-9478-6fe8e382264e",
                    },
                  ],
                },
                nodes: [],
              },
              {
                id: "4fc246e6-196d-44ff-a72d-b4a6fb6ecc66",
                parentId: "d1609407-9100-4189-9d47-12adb66efea3",
                key: "4fc246e6-196d-44ff-a72d-b4a6fb6ecc66",
                treeVisible: true,
                label: "Wall-Ext_102Bwk-75Ins-100LBlk-12P",
                meshInfo: {
                  $id: "4fc246e6-196d-44ff-a72d-b4a6fb6ecc66",
                  CustomCategory: null,
                  TopCategory: "Walls",
                  SubCategory: "Walls",
                  PhysicalCategory: "Walls",
                  Type: "Basic Wall",
                  Name: "Wall-Ext_102Bwk-75Ins-100LBlk-12P",
                  Quantity: 1,
                  Unit: "",
                  Count: 1,
                  Area: 62.89920110261073,
                  AreaUnit: "SquareMeter",
                  RevitAreaUnit: "Square meters",
                  Volume: 18.223138342806305,
                  VolumeUnit: "CubicMeter",
                  RevitVolumeUnit: "Cubic meters",
                  NominalWeight: 0,
                  NominalWeightUnit: "Undefined",
                  RevitNominalWeightUnit: "",
                  Length: 8000,
                  LengthUnit: "Millimeter",
                  RevitLengthUnit: "Millimeters",
                  Width: 290,
                  WidthUnit: "Millimeter",
                  RevitWidthUnit: "Millimeters",
                  Depth: 7999.999999999999,
                  DepthUnit: "Millimeter",
                  RevitDepthUnit: "Millimeters",
                  Connectors: [],
                  Diameter: 0,
                  DiameterUnit: "Undefined",
                  ConnectorWidth: 0,
                  ConnectorWidthUnit: "Undefined",
                  ConnectorHeight: 0,
                  ConnectorHeightUnit: "Undefined",
                  Perimeter: 0,
                  PerimeterUnit: "Undefined",
                  MaterialIds: [],
                  MaterialNames: [],
                  LevelName: "Level 0",
                  Uniformat: "",
                  OmniClass: null,
                  MasterFormat: null,
                  UniqueId: "f2a469cf-255d-48c6-9a06-6b3e70144c2f-0004e4e2",
                  Color: "",
                  MaterialsData: [
                    {
                      $ref: "29cf1a5b-d6d0-4e44-93a0-5916076244f1",
                    },
                    {
                      $ref: "ac5f2f80-35d3-4b5e-a923-e56a59db027d",
                    },
                    {
                      $ref: "3b99d9f0-c307-4597-ba18-8546195b1c8e",
                    },
                    {
                      $ref: "b777b417-7558-4439-9478-6fe8e382264e",
                    },
                  ],
                },
                nodes: [],
              },
              {
                id: "2ea09ccf-614e-417e-ad66-7075fe4b3258",
                parentId: "d1609407-9100-4189-9d47-12adb66efea3",
                key: "2ea09ccf-614e-417e-ad66-7075fe4b3258",
                treeVisible: true,
                label: "Wall-Ext_102Bwk-75Ins-100LBlk-12P",
                meshInfo: {
                  $id: "2ea09ccf-614e-417e-ad66-7075fe4b3258",
                  CustomCategory: null,
                  TopCategory: "Walls",
                  SubCategory: "Walls",
                  PhysicalCategory: "Walls",
                  Type: "Basic Wall",
                  Name: "Wall-Ext_102Bwk-75Ins-100LBlk-12P",
                  Quantity: 1,
                  Unit: "",
                  Count: 1,
                  Area: 77.80161842132796,
                  AreaUnit: "SquareMeter",
                  RevitAreaUnit: "Square meters",
                  Volume: 22.562469342185025,
                  VolumeUnit: "CubicMeter",
                  RevitVolumeUnit: "Cubic meters",
                  NominalWeight: 0,
                  NominalWeightUnit: "Undefined",
                  RevitNominalWeightUnit: "",
                  Length: 9725.202302665995,
                  LengthUnit: "Millimeter",
                  RevitLengthUnit: "Millimeters",
                  Width: 290,
                  WidthUnit: "Millimeter",
                  RevitWidthUnit: "Millimeters",
                  Depth: 7999.999999999999,
                  DepthUnit: "Millimeter",
                  RevitDepthUnit: "Millimeters",
                  Connectors: [],
                  Diameter: 0,
                  DiameterUnit: "Undefined",
                  ConnectorWidth: 0,
                  ConnectorWidthUnit: "Undefined",
                  ConnectorHeight: 0,
                  ConnectorHeightUnit: "Undefined",
                  Perimeter: 0,
                  PerimeterUnit: "Undefined",
                  MaterialIds: [],
                  MaterialNames: [],
                  LevelName: "Level 0",
                  Uniformat: "",
                  OmniClass: null,
                  MasterFormat: null,
                  UniqueId: "e5d65611-0284-4ee9-be66-0fd1d93ef78f-0004e59f",
                  Color: "",
                  MaterialsData: [
                    {
                      $ref: "29cf1a5b-d6d0-4e44-93a0-5916076244f1",
                    },
                    {
                      $ref: "ac5f2f80-35d3-4b5e-a923-e56a59db027d",
                    },
                    {
                      $ref: "3b99d9f0-c307-4597-ba18-8546195b1c8e",
                    },
                    {
                      $ref: "b777b417-7558-4439-9478-6fe8e382264e",
                    },
                  ],
                },
                nodes: [],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    gate: "NOT",
    key: "f1ea073e-0f8e-47a2-9e97-a1fdbdd03a2b",
    label: "Project Project",
    id: "f1ea073e-0f8e-47a2-9e97-a1fdbdd03a2b",
    parentId: "f1ea073e-0f8e-47a2-9e97-a1fdbdd03a2b",
    treeVisible: true,
    nodes: [
      {
        id: "ecd9eb3c-c64e-4921-88af-63046ed0f5e5",
        parentId: "f1ea073e-0f8e-47a2-9e97-a1fdbdd03a2b",
        treeVisible: true,
        key: "ecd9eb3c-c64e-4921-88af-63046ed0f5e5",
        label: "Walls",
        nodes: [
          {
            id: "d1609407-9100-4189-9d47-12adb66efea3",
            parentId: "ecd9eb3c-c64e-4921-88af-63046ed0f5e5",
            treeVisible: true,
            key: "d1609407-9100-4189-9d47-12adb66efea3",
            label: "Wall-Ext_102Bwk-75Ins-100LBlk-12P",
            nodes: [
              {
                id: "d7410c51-d3b5-4ea6-8686-ce368aac17e3",
                parentId: "d1609407-9100-4189-9d47-12adb66efea3",
                key: "d7410c51-d3b5-4ea6-8686-ce368aac17e3",
                treeVisible: true,
                label: "Wall-Ext_102Bwk-75Ins-100LBlk-12P",
                meshInfo: {
                  $id: "d7410c51-d3b5-4ea6-8686-ce368aac17e3",
                  CustomCategory: null,
                  TopCategory: "Walls",
                  SubCategory: "Walls",
                  PhysicalCategory: "Walls",
                  Type: "Basic Wall",
                  Name: "Wall-Ext_102Bwk-75Ins-100LBlk-12P",
                  Quantity: 1,
                  Unit: "",
                  Count: 1,
                  Area: 70.58624335802492,
                  AreaUnit: "SquareMeter",
                  RevitAreaUnit: "Square meters",
                  Volume: 20.32023564408941,
                  VolumeUnit: "CubicMeter",
                  RevitVolumeUnit: "Cubic meters",
                  NominalWeight: 0,
                  NominalWeightUnit: "Undefined",
                  RevitNominalWeightUnit: "",
                  Length: 8600,
                  LengthUnit: "Millimeter",
                  RevitLengthUnit: "Millimeters",
                  Width: 290,
                  WidthUnit: "Millimeter",
                  RevitWidthUnit: "Millimeters",
                  Depth: 7999.999999999999,
                  DepthUnit: "Millimeter",
                  RevitDepthUnit: "Millimeters",
                  Connectors: [],
                  Diameter: 0,
                  DiameterUnit: "Undefined",
                  ConnectorWidth: 0,
                  ConnectorWidthUnit: "Undefined",
                  ConnectorHeight: 0,
                  ConnectorHeightUnit: "Undefined",
                  Perimeter: 0,
                  PerimeterUnit: "Undefined",
                  MaterialIds: [],
                  MaterialNames: [],
                  LevelName: "Level 0",
                  Uniformat: "",
                  OmniClass: null,
                  MasterFormat: null,
                  UniqueId: "f2a469cf-255d-48c6-9a06-6b3e70144c2f-0004e483",
                  Color: "181, 230, 179",
                  MaterialsData: [
                    {
                      $ref: "29cf1a5b-d6d0-4e44-93a0-5916076244f1",
                    },
                    {
                      $ref: "ac5f2f80-35d3-4b5e-a923-e56a59db027d",
                    },
                    {
                      $ref: "3b99d9f0-c307-4597-ba18-8546195b1c8e",
                    },
                    {
                      $ref: "b777b417-7558-4439-9478-6fe8e382264e",
                    },
                  ],
                },
                nodes: [],
              },
              {
                id: "a37bc96e-a4be-48a1-adae-a7e55b5714a5",
                parentId: "d1609407-9100-4189-9d47-12adb66efea3",
                key: "a37bc96e-a4be-48a1-adae-a7e55b5714a5",
                treeVisible: true,
                label: "Wall-Ext_102Bwk-75Ins-100LBlk-12P",
                meshInfo: {
                  $id: "a37bc96e-a4be-48a1-adae-a7e55b5714a5",
                  CustomCategory: null,
                  TopCategory: "Walls",
                  SubCategory: "Walls",
                  PhysicalCategory: "Walls",
                  Type: "Basic Wall",
                  Name: "Wall-Ext_102Bwk-75Ins-100LBlk-12P",
                  Quantity: 1,
                  Unit: "",
                  Count: 1,
                  Area: 34.06907213721681,
                  AreaUnit: "SquareMeter",
                  RevitAreaUnit: "Square meters",
                  Volume: 9.712626013104268,
                  VolumeUnit: "CubicMeter",
                  RevitVolumeUnit: "Cubic meters",
                  NominalWeight: 0,
                  NominalWeightUnit: "Undefined",
                  RevitNominalWeightUnit: "",
                  Length: 4200,
                  LengthUnit: "Millimeter",
                  RevitLengthUnit: "Millimeters",
                  Width: 290,
                  WidthUnit: "Millimeter",
                  RevitWidthUnit: "Millimeters",
                  Depth: 7999.999999999999,
                  DepthUnit: "Millimeter",
                  RevitDepthUnit: "Millimeters",
                  Connectors: [],
                  Diameter: 0,
                  DiameterUnit: "Undefined",
                  ConnectorWidth: 0,
                  ConnectorWidthUnit: "Undefined",
                  ConnectorHeight: 0,
                  ConnectorHeightUnit: "Undefined",
                  Perimeter: 0,
                  PerimeterUnit: "Undefined",
                  MaterialIds: [],
                  MaterialNames: [],
                  LevelName: "Level 0",
                  Uniformat: "",
                  OmniClass: null,
                  MasterFormat: null,
                  UniqueId: "f2a469cf-255d-48c6-9a06-6b3e70144c2f-0004e48f",
                  Color: "",
                  MaterialsData: [
                    {
                      $ref: "29cf1a5b-d6d0-4e44-93a0-5916076244f1",
                    },
                    {
                      $ref: "ac5f2f80-35d3-4b5e-a923-e56a59db027d",
                    },
                    {
                      $ref: "3b99d9f0-c307-4597-ba18-8546195b1c8e",
                    },
                    {
                      $ref: "b777b417-7558-4439-9478-6fe8e382264e",
                    },
                  ],
                },
                nodes: [],
              },
              {
                id: "4fc246e6-196d-44ff-a72d-b4a6fb6ecc66",
                parentId: "d1609407-9100-4189-9d47-12adb66efea3",
                key: "4fc246e6-196d-44ff-a72d-b4a6fb6ecc66",
                treeVisible: true,
                label: "Wall-Ext_102Bwk-75Ins-100LBlk-12P",
                meshInfo: {
                  $id: "4fc246e6-196d-44ff-a72d-b4a6fb6ecc66",
                  CustomCategory: null,
                  TopCategory: "Walls",
                  SubCategory: "Walls",
                  PhysicalCategory: "Walls",
                  Type: "Basic Wall",
                  Name: "Wall-Ext_102Bwk-75Ins-100LBlk-12P",
                  Quantity: 1,
                  Unit: "",
                  Count: 1,
                  Area: 62.89920110261073,
                  AreaUnit: "SquareMeter",
                  RevitAreaUnit: "Square meters",
                  Volume: 18.223138342806305,
                  VolumeUnit: "CubicMeter",
                  RevitVolumeUnit: "Cubic meters",
                  NominalWeight: 0,
                  NominalWeightUnit: "Undefined",
                  RevitNominalWeightUnit: "",
                  Length: 8000,
                  LengthUnit: "Millimeter",
                  RevitLengthUnit: "Millimeters",
                  Width: 290,
                  WidthUnit: "Millimeter",
                  RevitWidthUnit: "Millimeters",
                  Depth: 7999.999999999999,
                  DepthUnit: "Millimeter",
                  RevitDepthUnit: "Millimeters",
                  Connectors: [],
                  Diameter: 0,
                  DiameterUnit: "Undefined",
                  ConnectorWidth: 0,
                  ConnectorWidthUnit: "Undefined",
                  ConnectorHeight: 0,
                  ConnectorHeightUnit: "Undefined",
                  Perimeter: 0,
                  PerimeterUnit: "Undefined",
                  MaterialIds: [],
                  MaterialNames: [],
                  LevelName: "Level 0",
                  Uniformat: "",
                  OmniClass: null,
                  MasterFormat: null,
                  UniqueId: "f2a469cf-255d-48c6-9a06-6b3e70144c2f-0004e4e2",
                  Color: "",
                  MaterialsData: [
                    {
                      $ref: "29cf1a5b-d6d0-4e44-93a0-5916076244f1",
                    },
                    {
                      $ref: "ac5f2f80-35d3-4b5e-a923-e56a59db027d",
                    },
                    {
                      $ref: "3b99d9f0-c307-4597-ba18-8546195b1c8e",
                    },
                    {
                      $ref: "b777b417-7558-4439-9478-6fe8e382264e",
                    },
                  ],
                },
                nodes: [],
              },
              {
                id: "2ea09ccf-614e-417e-ad66-7075fe4b3258",
                parentId: "d1609407-9100-4189-9d47-12adb66efea3",
                key: "2ea09ccf-614e-417e-ad66-7075fe4b3258",
                treeVisible: true,
                label: "Wall-Ext_102Bwk-75Ins-100LBlk-12P",
                meshInfo: {
                  $id: "2ea09ccf-614e-417e-ad66-7075fe4b3258",
                  CustomCategory: null,
                  TopCategory: "Walls",
                  SubCategory: "Walls",
                  PhysicalCategory: "Walls",
                  Type: "Basic Wall",
                  Name: "Wall-Ext_102Bwk-75Ins-100LBlk-12P",
                  Quantity: 1,
                  Unit: "",
                  Count: 1,
                  Area: 77.80161842132796,
                  AreaUnit: "SquareMeter",
                  RevitAreaUnit: "Square meters",
                  Volume: 22.562469342185025,
                  VolumeUnit: "CubicMeter",
                  RevitVolumeUnit: "Cubic meters",
                  NominalWeight: 0,
                  NominalWeightUnit: "Undefined",
                  RevitNominalWeightUnit: "",
                  Length: 9725.202302665995,
                  LengthUnit: "Millimeter",
                  RevitLengthUnit: "Millimeters",
                  Width: 290,
                  WidthUnit: "Millimeter",
                  RevitWidthUnit: "Millimeters",
                  Depth: 7999.999999999999,
                  DepthUnit: "Millimeter",
                  RevitDepthUnit: "Millimeters",
                  Connectors: [],
                  Diameter: 0,
                  DiameterUnit: "Undefined",
                  ConnectorWidth: 0,
                  ConnectorWidthUnit: "Undefined",
                  ConnectorHeight: 0,
                  ConnectorHeightUnit: "Undefined",
                  Perimeter: 0,
                  PerimeterUnit: "Undefined",
                  MaterialIds: [],
                  MaterialNames: [],
                  LevelName: "Level 0",
                  Uniformat: "",
                  OmniClass: null,
                  MasterFormat: null,
                  UniqueId: "e5d65611-0284-4ee9-be66-0fd1d93ef78f-0004e59f",
                  Color: "",
                  MaterialsData: [
                    {
                      $ref: "29cf1a5b-d6d0-4e44-93a0-5916076244f1",
                    },
                    {
                      $ref: "ac5f2f80-35d3-4b5e-a923-e56a59db027d",
                    },
                    {
                      $ref: "3b99d9f0-c307-4597-ba18-8546195b1c8e",
                    },
                    {
                      $ref: "b777b417-7558-4439-9478-6fe8e382264e",
                    },
                  ],
                },
                nodes: [],
              },
            ],
          },
        ],
      },
    ],
  },
];



export const filterDynamicData = [
  {
      "gate": "AND",
      "id": "60bba16e-5d49-43da-a227-7379ad39d759",
      "key": "60bba16e-5d49-43da-a227-7379ad39d759",
      "label": "Project Snowdon ",
      "nodes": [
          {
              "id": "dea59dc3-4d26-4281-91f6-7cea5031a643",
              "key": "dea59dc3-4d26-4281-91f6-7cea5031a643",
              "label": "Food Service Equipment",
              "nodes": [
                  {
                      "id": "6592f878-a16f-4fa9-b449-544a79da94da",
                      "key": "6592f878-a16f-4fa9-b449-544a79da94da",
                      "label": "36\" x 38\"",
                      "nodes": [
                          {
                              "id": "d71f24e6-aaa1-4233-a583-14ea93564a5c",
                              "key": "d71f24e6-aaa1-4233-a583-14ea93564a5c",
                              "label": "IsFamilyInstance",
                              "logic": [
                                  {
                                      "label": "Different",
                                      "value": "!="
                                  }
                              ],
                              "meshInfo": {
                                  "$id": "d71f24e6-aaa1-4233-a583-14ea93564a5c",
                                  "Area": 24.004860843605343,
                                  "AreaUnit": "SquareFoot",
                                  "AssociatedSheets": null,
                                  "Color": "150, 202, 105",
                                  "ConnectorHeight": 0,
                                  "ConnectorHeightUnit": "Undefined",
                                  "Connectors": [
                                  ],
                                  "ConnectorWidth": 0,
                                  "ConnectorWidthUnit": "Undefined",
                                  "Count": 1,
                                  "CustomCategory": null,
                                  "CustomLevelName": "",
                                  "Depth": 1,
                                  "DepthUnit": "Foot",
                                  "Diameter": 0,
                                  "DiameterUnit": "Undefined",
                                  "FloorPoint": "-3.92",
                                  "IsFamilyInstance": true,
                                  "Length": 3.333333333333343,
                                  "LengthUnit": "Foot",
                                  "LevelName": "L1 - Block 35",
                                  "Location": "",
                                  "MasterFormat": null,
                                  "MaterialIds": [
                                      "8b7e8681-7346-452a-b757-63c42dc46dd6-0010e1be",
                                      "8b7e8681-7346-452a-b757-63c42dc46dd6-0010e1c4"
                                  ],
                                  "MaterialNames": [
                                      "Unassigned | Unassigned | Matte Black",
                                      "Unassigned | Unassigned | Stainless Steel, Polished"
                                  ],
                                  "MaterialsData": [
                                      {
                                          "$ref": "dcf54d07-427b-4ec1-b4fd-db3482c99ddc"
                                      },
                                      {
                                          "$ref": "b9639100-7c3e-4e36-99d3-f6a598a14198"
                                      }
                                  ],
                                  "Name": "36\" x 38\"",
                                  "NominalWeight": 0,
                                  "NominalWeightUnit": "Undefined",
                                  "OmniClass": "",
                                  "Perimeter": 0,
                                  "PerimeterUnit": "Undefined",
                                  "PhysicalCategory": "Food Service Equipment",
                                  "Quantity": 1,
                                  "RevitAreaUnit": "Square feet",
                                  "RevitDepthUnit": "Feet and fractional inches",
                                  "RevitLengthUnit": "Feet and fractional inches",
                                  "RevitNominalWeightUnit": "",
                                  "RevitVolumeUnit": "Cubic feet",
                                  "RevitWidthUnit": "Feet and fractional inches",
                                  "SubCategory": "Food Service Equipment",
                                  "TopCategory": "Food Service Equipment",
                                  "Type": "Range-4 Burner",
                                  "Uniformat": "E1090320",
                                  "UniqueId": "8b7e8681-7346-452a-b757-63c42dc46dd6-00115535",
                                  "Unit": "",
                                  "Volume": 8.526041666666652,
                                  "VolumeUnit": "CubicFoot",
                                  "Width": 3.1666666666666714,
                                  "WidthUnit": "Foot"
                              },
                              "nodes": [
                              ]
                          }
                      ]
                  }
              ]
          }
      ],
      "treeVisible": true
  },
  {
      "gate": "OR",
      "id": "60bba16e-5d49-43da-a227-7379ad39d759",
      "key": "60bba16e-5d49-43da-a227-7379ad39d759",
      "label": "Project Snowdon ",
      "nodes": [
          {
              "id": "2d74512e-d6d5-4bb8-bcd5-45e9394ba93e",
              "key": "2d74512e-d6d5-4bb8-bcd5-45e9394ba93e",
              "label": "Generic Models",
              "nodes": [
                  {
                      "id": "75c1f4db-dded-4c7a-86f7-2ea5e06cb0fb",
                      "key": "75c1f4db-dded-4c7a-86f7-2ea5e06cb0fb",
                      "label": "with Sill",
                      "nodes": [
                          {
                              "id": "d9d818e9-720b-44ba-9aef-b64d8e328d50",
                              "key": "d9d818e9-720b-44ba-9aef-b64d8e328d50",
                              "label": "Location",
                              "logic": [
                                  {
                                      "label": "Less than",
                                      "value": "<"
                                  }
                              ],
                              "meshInfo": {
                                  "$id": "d9d818e9-720b-44ba-9aef-b64d8e328d50",
                                  "Area": 11.658273051895844,
                                  "AreaUnit": "SquareFoot",
                                  "AssociatedSheets": null,
                                  "Color": "115, 73, 233",
                                  "ConnectorHeight": 0,
                                  "ConnectorHeightUnit": "Undefined",
                                  "Connectors": [
                                  ],
                                  "ConnectorWidth": 0,
                                  "ConnectorWidthUnit": "Undefined",
                                  "Count": 1,
                                  "CustomCategory": null,
                                  "CustomLevelName": "Block 43 - Parapet",
                                  "Depth": 6.781110140697919,
                                  "DepthUnit": "Foot",
                                  "Diameter": 0,
                                  "DiameterUnit": "Undefined",
                                  "FloorPoint": "54.08",
                                  "IsFamilyInstance": true,
                                  "Length": 3.4263118053035555,
                                  "LengthUnit": "Foot",
                                  "LevelName": "L5",
                                  "Location": "",
                                  "MasterFormat": null,
                                  "MaterialIds": [
                                  ],
                                  "MaterialNames": [
                                  ],
                                  "MaterialsData": [
                                      {
                                          "$ref": "c2bc7d9f-4ecb-4483-877d-dc487e70777c"
                                      }
                                  ],
                                  "Name": "with Sill",
                                  "NominalWeight": 0,
                                  "NominalWeightUnit": "Undefined",
                                  "OmniClass": "",
                                  "Perimeter": 0,
                                  "PerimeterUnit": "Undefined",
                                  "PhysicalCategory": "Generic Models",
                                  "Quantity": 1,
                                  "RevitAreaUnit": "Square feet",
                                  "RevitDepthUnit": "Feet and fractional inches",
                                  "RevitLengthUnit": "Feet and fractional inches",
                                  "RevitNominalWeightUnit": "",
                                  "RevitVolumeUnit": "Cubic feet",
                                  "RevitWidthUnit": "Feet and fractional inches",
                                  "SubCategory": "Generic Models",
                                  "TopCategory": "Generic Models",
                                  "Type": "Trim-Window-Exterior-Flat",
                                  "Uniformat": "",
                                  "UniqueId": "049439b4-5467-47c4-a72e-459e7fd736c2-001017ae",
                                  "Unit": "",
                                  "Volume": 0.2734742141172542,
                                  "VolumeUnit": "CubicFoot",
                                  "Width": 1.651483250041906,
                                  "WidthUnit": "Foot"
                              },
                              "nodes": [
                              ]
                          }
                      ]
                  }
              ]
          }
      ],
      "treeVisible": true
  }
]
